export default {
    install: function (Vue, options) {
        Vue.directive('alphabetOnly', {
            bind(el, binding, vnode) {
                const input = el.querySelector('input, textarea')
                if (input) {
                    input.addEventListener('keydown', (evt) => {
                        let charCode = (evt.which) ? evt.which : evt.keyCode;
                        if (charCode > 31 && (charCode < 64 || charCode > 90)) {
                            evt.preventDefault();
                        }
                    })
                }
            }
        })
        Vue.directive('numericOnly', {
            bind(el, binding, vnode) {
                const input = el.querySelector('input, textarea')
                if (input) {
                    input.addEventListener('keydown', (evt) => {
                        let charCode = (evt.which) ? evt.which : evt.keyCode;
                        if (((charCode == 65 || charCode == 86 || charCode == 67) && 
                            (evt.ctrlKey === true || evt.metaKey === true)) ||
                            (charCode >= 35 && charCode <= 40)) {
                            return;
                        }
                        if (charCode != 190 && charCode != 110 && charCode > 31 && 
                            (charCode < 48 || charCode > 57) &&
                            (charCode < 96 || charCode > 105)) {
                            evt.preventDefault();
                        }
                    })
                }
            }
        })
        Vue.directive('enterAsTab', {
            bind: function (el, binding, vnode) {
                const elements = el.querySelectorAll('input, textarea, button');
                const arr = Array.from(elements)
                arr.forEach(child => {
                    if (child.matches('textarea,button')) {
                        return;
                    }
                    child.addEventListener('keydown', (ev) => {
                        if (ev.keyCode === 13) {
                            ev.preventDefault();
                            let next = arr.indexOf(child) + 1;
                            if (next > arr.length - 1) {
                                next = 0
                            }
                            arr[next].focus();
                        }
                    })
                })
            }
        })
    }
}
